webpackJsonp([16700144737804],{

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ContactFind = __webpack_require__(69);
	
	var _ContactFind2 = _interopRequireDefault(_ContactFind);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Clear = __webpack_require__(34);
	
	var _Clear2 = _interopRequireDefault(_Clear);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _contact = __webpack_require__(103);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ws = function (_Component) {
	    _inherits(Ws, _Component);
	
	    function Ws() {
	        _classCallCheck(this, Ws);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Ws.prototype.render = function render() {
	        var slug = this.props.pathContext.slug;
	
	
	        var title = "Stage Web designer (H/F)";
	        var description = "Web & Mobile UI/UX";
	        var goto = "";
	
	        var postNode = {
	            "frontmatter": {
	                "title": title,
	                "description": "Venez sublimer vos créations !",
	                "cover": _contact2.default
	            }
	        };
	
	        return _react2.default.createElement(
	            "div",
	            { className: "contact" },
	            _react2.default.createElement(_reactHelmet2.default, { title: title }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _contact2.default }),
	            _react2.default.createElement(
	                "article",
	                { className: "container row-bottom-padded-md row-top-padded-md" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12" },
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Qui sommes nous ?"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Integral Service est un studio Web rattach\xE9 \xE0 la soci\xE9t\xE9 Integral System (2003) sp\xE9cialis\xE9e dans la r\xE9alisation d'application Web et mobile sur-mesure."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Nos derniers projets palpitants en date sont la cr\xE9ation d'un jeu de simulation de gestion de soci\xE9t\xE9 pour la soci\xE9t\xE9 IPAJE, la cr\xE9ation d'un site E-Commerce \xE9ph\xE9m\xE8re pour Michelin, la r\xE9alisation d'une application m\xE9tier pour les 3000 infirmi\xE8res du groupe Synlab Labco ou encore la r\xE9alisation d'un r\xE9seau social pour les compositeurs de musique, sans parler des portails pour Emma\xFCs"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "C'est dans ce cadre de croissance et d'int\xE9gration de nouvelles offres que nous recherchons un ou une ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Web designer"
	                        ),
	                        " pour rejoindre notre \xE9quipe web et mobile."
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Mission"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Vous travaillez en collaboration avec les \xE9quipes de d\xE9veloppement actuellement en place sur de nombreux sujets passionnants:"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            "Design d'applications mobile hybride et Web Apps / ",
	                            _react2.default.createElement(
	                                "a",
	                                { href: "/quest-ce-quune-progressive-web-app", title: "Progressive web apps", target: "_blank" },
	                                "Porgressive Web apps"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            "Refonte graphiques des sites de la soci\xE9t\xE9"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "le tout dans une ambiance d'entraide et partage de connaissance au sein des \xE9quipes, pour des projets internes ou projets client encore plus passionnant !"
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Profil"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            "Une vraie volonter d'innover dans la r\xE9alisation d'interface utilisateur"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            "Une passion pour tout ce qui entoure le web et le mobile"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Vous avez un super esprit d'\xE9quipe, un bon relationnel, vous \xEAtes dynamique, savez travailler de fa\xE7on autonome et \xEAtes dot\xE9 d'une bonne capacit\xE9 d'\xE9coute."
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 p-3 d-flex justify-content-center" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: "/contact", title: "Postuler pour l'offre de d\xE9veloppeur Symfony PHP" },
	                            _react2.default.createElement(
	                                "button",
	                                { className: "btn btn-primary" },
	                                "Postuler"
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Clear2.default, null),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return Ws;
	}(_react.Component);
	
	exports.default = Ws;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-web-designer-offre-emploi-jsx-3ef118843a3a0a13cf91.js